<template>
    <div>
        <div style="z-index: 999; margin-top: 20px">
            <section>
                <div>

                    <!--<select v-model="sessionEvaluation" name="session_set">
                        <option v-for="(label,index) in dropdownSession" :value="index">
                            {{label}}
                        </option>
                    </select> -->
                     <div class="pull-right">
                                <label> Leadership level</label>
                                <select v-model="setFilter"  name="filter_set">
                                    <option v-for="(label,index) in dropdownSet" :value="index">
                                        {{label}}
                                    </option>
                                </select>


                                <button class="btn btn-link btn-xs" style="width: 20px;background: transparent;color: #1767a2 "  type="button" @click="drawGraph()"><i class="fas fa-filter fa-2x" style="color: #1767a2 !important; "></i></button>
                            </div>

                   <!--         <select v-model="peopleFilter"  name="filter_people">
                                <option v-for="(label, index) in dropdownPeople" :value="index">
                                    {{label}}
                                </option>
                            </select>
                            -->
                </div>

            </section>
        </div>
    </div>
</template>
<script>

        export default {

            data () {
                return {
                    setFilter: null,
                    sessionEvaluation: null,
                    peopleFilter: "direct",
                    dataGraphs : {}
                }
            },

            mounted () {
                console.log(this.dropdownSession);
                this.setFilter= Object.keys(this.dropdownSet)[0];
                this.sessionEvaluation= Object.keys(this.dropdownSession)[0];
                this.drawGraph();
                //this.setFilter = this.dropdownSet[0].id;
            // Overwriting base render method with actual data.
            },
        methods: {

                drawGraph(){

                    axios.get(this.endPointRouteName,{
                        params: {
                            setFilter           : this.setFilter,
                            peopleFilter        : this.peopleFilter,
                            sessionEvaluation   : this.sessionEvaluation,
                            mode                : this.mode
                        },
                    })

                        .then((response) => {
                            this.dataGraphs = response.data.dataGraphs;
                            app.__vue__.$refs[this.refGraphWidget].fetchDatas(response.data);
                        });
                }
        },
        props: {
            dropdownSession: {
                type: Object,
                required: true,
            },
            dropdownSet: {
                type: Object,
                required: true,
            },
            dropdownPeople: {
                type: Object,
                required: true,
            },
            refGraphWidget : {
                type: String,
                required: true
            },
            endPointRouteName : {
                type: String,
                required: true
            },
            mode :{
                type : Number,
                required : true
            }

        }

    }
</script>
